module.exports = __webpack_public_path__ + "static/media/ic_accept_hover.16e11e12.svg";